import React, { useEffect, useRef, useState } from 'react';
import moment from "moment";
import userImage from "../../files/user.png";

const ChatMessage = (pops) => {
    const messageRef = useRef(null);
    const [isVisible, setIsVisible] = useState(Boolean(pops.isOptimistic));
    const style = pops.isSender ? "chat-message-right" : "chat-message-left";
    const background = pops.isSender ? "bg-light-sender" : "bg-light-receiver";
    const headerAlignClass = pops.isSender ? "message-header-sender" : "message-header-receiver";
    const timestampAlignClass = pops.isSender ? "message-time-sender" : "message-time-receiver";
    const bubbleClass = pops.isSender ? "chat-bubble sender-bubble" : "chat-bubble receiver-bubble";
    const pendingClass = pops.isOptimistic ? "chat-message-pending" : "";
    const profile = pops.image != undefined && pops.image != "" ? process.env.REACT_APP_VIDEO_CALL_REQUEST + "/" + pops.image : userImage;

    useEffect(() => {
        const element = messageRef.current;
        if (!element) {
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.01, rootMargin: "0px 0px -40px 0px" }
        );

        observer.observe(element);
        const fallback = setTimeout(() => setIsVisible(true), 450);
        return () => {
            clearTimeout(fallback);
            observer.disconnect();
        };
    }, []);

    return (
        <>
            {pops.dataModel && (
                <div ref={messageRef} className={style + " pb-4 chat-message-animate " + (isVisible ? "chat-message-visible " : "") + pendingClass}>
                    <div className="display-center">
                        <img
                            src={profile}
                            className="rounded-circle mr-1 chat-avatar"
                            alt={pops.name}
                            width="40"
                            height="40"
                        />
                    </div>
                    <div className={"flex-shrink-1 rounded py-2 px-3 ml-3 right-date-time " + background + " " + bubbleClass}>
                        <div className={"font-weight-bold mb-1 display-center-message-time chat-meta-row " + headerAlignClass}>
                            <span className="chat-sender-name">{pops.name}</span>
                            <div className={"text-muted small text-nowrap message-time " + timestampAlignClass}>
                                <i className="mdi mdi-clock-outline chat-time-icon" />
                                {moment(pops.dataModel.createdAt).format('MMMM DD, YYYY HH:mm')}
                            </div>
                        </div>
                        <div className="chat-message-body">{pops.dataModel.body}</div>
                    </div>
                </div>
            )}
        </>        
    );
};

export default ChatMessage;